import styled from "styled-components";

const Container = styled.div`
  min-height: 100vh;
`;

const DashboardContainer = styled.div`
  padding-right: 40px;
  padding-left: 20px;
  padding-top: 20px;
  padding-bottom: 20px;
`;

const HeaderContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 16px;
`;

export { Container, DashboardContainer, HeaderContainer };
